<template>
  <div>
    <v-select
      density="compact"
      style="padding-left: 15px; padding-right: 15px; padding-bottom: 15px;"
      hide-details
      :items="dataSelection"
      v-model="dataConfigSelected"
      class="charts-selector"
      @change="handleDataConfigChange"
    ></v-select>
    <v-select
      density="compact"
      style="padding-left: 15px; padding-right: 15px; padding-bottom: 15px;"
      hide-details
      :items="chartTypeSelection"
      v-model="chartTypeConfigSelected"
      class="charts-selector"
      :return-object="true"
    >
    </v-select>
    <component :is="chartTypeConfigSelected.chartComponent" v-bind="getProps" />
  </div>
</template>

<script>
import LineGraph from "@/components/events/LineGraph.vue";
import SentimentChart from "@/components/common/details/SentimentChart.vue";
import VerifiedEventsPieGraph from "@/components/events/VerifiedEventsPieGraph.vue";
import VerifiedEventsBarGraph from "@/components/events/VerifiedEventsBarGraph.vue";
import { CHART_TYPE_SELECTION } from "@/common/constants/charts";

export default {
  name: "ChartSelector",
  props: {
    chartConfig: {},
    chartsData: {},
    searchParams: {},
    defaultSelected: {
      type: Object,
    },
    legend: {
      type: Array,
      required: false,
    },
    graphComponent: {
      type: Object,
    },
  },
  computed: {
    getProps() {
      const props = this.chartTypeConfigSelected.props || {};
      switch (this.chartTypeConfigSelected.chartComponent) {
        case LineGraph:
          return {
            ...props,
            chartData:
              this.chartTypeConfigSelected.getChartData(this.chartsData) || {},
            filterSelection: this.searchParams[
              this.dataConfigSelected.filterSelection
            ],
            width: "98%",
            description: this.dataConfigSelected.description,
            tooltipFormatterName: "tooltipFormatterPercentages",
          };
        case SentimentChart:
          return {
            ...props,
            histogram: this.chartsData.sentimentHistogram || [],
          };
        case VerifiedEventsPieGraph:
          return {
            ...props,
            width: "98%",
            chartData:
              this.chartTypeConfigSelected.getChartData(this.chartsData) || [],
          };
        case VerifiedEventsBarGraph:
          return {
            ...props,
            width: "98%",
            chartData:
              this.chartTypeConfigSelected.getChartData(this.chartsData) || {},
          };
        default:
          return {};
      }
    },
    chartTypeSelection() {
      return Object.keys(this.dataConfigSelected?.chartTypeConfigs).map(
        (chartTypeConfigKey) => {
          return this.buildChartTypeConfig(
            this.dataConfigSelected,
            chartTypeConfigKey
          );
        }
      );
    },
  },
  data: function () {
    return {
      CHART_TYPE_SELECTION: Object.values(CHART_TYPE_SELECTION),
      dataConfigSelected: this.defaultSelected,
      chartTypeConfigSelected: this.buildChartTypeConfig(
        this.defaultSelected,
        this.defaultSelected.defaultChartType
      ),
      dataSelection: this.chartConfig.map((chart) => {
        return { text: chart.title, value: chart };
      }),
    };
  },
  methods: {
    buildChartTypeConfig(dataConfig, chartTypeConfigKey) {
      return {
        ...CHART_TYPE_SELECTION[chartTypeConfigKey],
        ...dataConfig.chartTypeConfigs[chartTypeConfigKey],
      };
    },
    handleDataConfigChange(dataConfig) {
      this.chartTypeConfigSelected = this.buildChartTypeConfig(
        dataConfig,
        dataConfig.defaultChartType
      );
    },
  },
};
</script>

<style></style>
